import { useNavigate, useParams } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Custom navigation hook that automatically prepends the dynamic route prefix (podIP).
 */
export const useAppNavigate = () => {
    const navigate = useNavigate();
    const { prefix } = useParams();

    return useCallback((path, options) => {
        if (path == -1) {
            return navigate(-1);
        }

        const normalizedPath = path.startsWith('/') ? path : `/${path}`;
        const prefixedPath = prefix ? `/${prefix}${normalizedPath}` : normalizedPath;

        return navigate(prefixedPath, options);
    }, [navigate, prefix]);
};

